module.exports = __webpack_public_path__ + "img/whathot_bg_mobile_green.285e219f.png";